'use client'

import Image from 'next/image'
import AngleDownIcon from '@/public/images/icons/angle-down.svg'
import { useSearchParams } from 'next/navigation'
import { useState } from 'react'
import { min } from 'lodash'
import { BountyListItem, BountyMeta } from '../actions'
import BountyCard from './BountyCard'

function LoadMore({ totalPages }: { totalPages: number }) {
  const searchParams = useSearchParams()
  const [page, setPage] = useState<number>(
    Number(searchParams.get('page')) || 1
  )

  const handleLoadMore = (pageNumber: number) => {
    const params = new URLSearchParams(searchParams)
    params.set('page', pageNumber.toString())
    setPage(Number(min([totalPages, pageNumber])))
    window.history.replaceState(null, '', `?${params.toString()}`)
  }

  return (
    <div
      onClick={() => handleLoadMore(page + 1)}
      className="flex items-center justify-center mt-6 text-sm font-medium cursor-pointer gap-2"
    >
      Load More
      <Image
        src={AngleDownIcon}
        alt="Load More"
        style={{ maxWidth: '100%', height: 'auto' }}
      />
    </div>
  )
}

const EmptyState = () => (
  <div className="flex flex-col w-full h-full items-center text-center">
    <span className="text-gray-900 text-lg font-semibold">
      No bug bounties here - yet
    </span>
    <p className="max-w-md text-gray-500">
      There are no bug bounties matching your search or filter options, but stay
      tuned or try another search!
    </p>
  </div>
)

interface BountyListProps {
  bounties: BountyListItem[]
  meta?: BountyMeta
  onLoadMore: () => void
}

export default function BountyList({ bounties, meta }: BountyListProps) {
  return (
    <div className="w-full flex flex-col gap-6">
      {bounties && bounties.length ? (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {bounties.map((bounty) => (
              <BountyCard key={bounty.id} bounty={bounty} />
            ))}
          </div>
          {meta && meta.page < meta.totalPages && (
            <div className="w-full text-center">
              <LoadMore totalPages={meta.totalPages} />
            </div>
          )}
        </>
      ) : (
        <EmptyState />
      )}
    </div>
  )
}
